import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  //  #####   ##   ##   #####   ######   #####
  //  ##  ##  ##   ##  ##   ##    ##    ##   ##
  //  #####   #######  ##   ##    ##    ##   ##
  //  ##      ##   ##  ##   ##    ##    ##   ##
  //  ##      ##   ##   #####     ##     #####

  let photoSlider = []
  const photoSliderItem = document.getElementsByClassName('js-topPhoto')
  if (photoSliderItem[0]) {
    for (const targetSlider of photoSliderItem) {
      const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
      photoSliderInit(targetSlider, sliderName)
    }
  }
  function photoSliderInit(targetSlider, sliderName) {
    photoSlider[sliderName] = new Swiper(targetSlider, {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 800, // アニメ速度
      loop: true, // ループ
      centeredSlides: true, // 中央のスライドを基準にする
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1, //表示数変更
      spaceBetween: 30, //スライド同士の間隔を空ける

      autoplay: {
        // オートオプション
        delay: 6000, // 待機時間
        disableOnInteraction: false, // 操作されたらオート解除
      },
    })
  }
}
